import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextField, Button, FormControlLabel, Checkbox, Grid, Paper, CircularProgress, Typography } from '@mui/material';

const DermoMedicineForm = ({ medicament, onClose, onSave }) => {
    const [showFileInput, setShowFileInput] = useState(false);
    const [photoFile, setPhotoFile] = useState(null);
    const [dermoPlaints, setDermoPlaints] = useState([]);
    const [loadingPlaints, setLoadingPlaints] = useState(true);
    const [formData, setFormData] = useState({
    photo: '',
    specialite: '',
    labo: '',
    gamme: '',
    appareil: '',
    sous_appareil: '',
    composition: '',
    effet: '',
    code_barre: '',
    quantite: '',
    forme: '',
    categorie: 'Para',
    utilisation: '',
    frequence: '',
    association_produits: '',
    temps_application: '',
    argument_vente: '',
    min_age_enfant: '',
    max_age_enfant: '',
    spf: '',
    phototype: '',
    femme_enceinte: false,
    ecran_teinte: false,
    ecran_couvrant: false,
    age_specifique_medic: '',
    allaitement: '',
    peau_seche: false,
    peau_normale: false,
    peau_mixte: false,
    peau_grasse: false,
    peau_tout_type: false,
    peau_sensible_atopique: false,
    sexe_specifique: '',
    sexe_specifique_medic: '',
    ordre: '',
    red_flags: '',
  });
  const handleFileChange = (e) => {
    setPhotoFile(e.target.files[0]);
  };

  useEffect(() => {
    const fetchDermoPlaints = async () => {
      setLoadingPlaints(true);
      try {
        const response = await axios.get('/complaints', {
          headers: {
            'x-access-token': localStorage.getItem('token') || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
          },
        });
        setDermoPlaints(response.data || []);
      } catch (error) {
        console.error('Error fetching dermo plaints:', error);
        alert('Failed to load dermo plaints');
      } finally {
        setLoadingPlaints(false);
      }
    };

    fetchDermoPlaints();
  }, []);

  useEffect(() => {
    if (medicament) {
      setFormData({
        ...medicament,
      });
    }
  }, [medicament]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let filteredData = Object.fromEntries(
      Object.entries(formData)
        .filter(([_, value]) => value !== false && value !== '' && value !== null && value !== undefined)
        .map(([key, value]) => [key, value === true ? 'oui' : value])
    );

    // Handle ecran_teinte case
    if (formData.ecran_teinte) {
      filteredData.ecran_teinte = 'oui';
    } else {
      filteredData.ecran_teinte = 'non';
    }
    let uploadedPhotoUrl = formData.photo;

      // Handle photo upload
      if (photoFile) {
        const formDataUpload = new FormData();
        formDataUpload.append('photo', photoFile);
        formDataUpload.append('specialite', formData.specialite);
        formDataUpload.append('forme', formData.forme);
        formDataUpload.append('dosage', formData.dosage);
        formDataUpload.append('qt_boite', formData.qt_boite);

        const uploadRes = await axios.post('/upload', formDataUpload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
        uploadedPhotoUrl = uploadRes.data.photoUrl;
      }
      filteredData = { ...filteredData, photo: uploadedPhotoUrl };

    try {
      if (medicament) {
        await axios.put(`cosmeticProduct/${medicament._id}`, filteredData, {
          headers: { 
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
      } else {
        await axios.post('cosmeticProduct', filteredData, {
          headers: { 
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem('token'),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        });
      }
      onSave();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 600, margin: 'auto' }}>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {[ 'code_barre','quantite','specialite', 'labo', 'gamme', 'forme', 'utilisation','composition', 'effet','appareil','sous_appareil','frequence', 'temps_application'  ,'categorie'  ,'argument_vente','min_age_enfant' ,'max_age_enfant','spf','red_flags','ordre','phototype','association_produits'].map((field) => (
            <Grid item xs={12} key={field}>
              <TextField 
                label={field.replace(/_/g, ' ')} 
                name={field} 
                value={formData[field]} 
                onChange={handleChange} 
                fullWidth 
                margin="normal"
                required={['code_barre', 'specialite', 'appareil', 'ordre'].includes(field)}
              />
            </Grid>
          ))}
        

          <Grid item xs={6}>
            <TextField
              select
              label="Sexe spécifique"
              name="sexe_specifique"
              value={formData.sexe_specifique || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              <option value="H">Homme</option>
              <option value="F">Femme</option>
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              label="Sexe spécifique (médicament)"
              name="sexe_specifique_medic"
              value={formData.sexe_specifique_medic || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              <option value="A">Adulte</option>
              <option value="E">Enfant</option>
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              label="Âge spécifique (médicament)"
              name="age_specifique_medic"
              value={formData.age_specifique_medic || ""}
              onChange={handleChange}
              fullWidth
              margin="normal"
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              <option value="A">Adulte</option>
              <option value="E">Enfant</option>
            </TextField>
          </Grid>

          
          {[
            "peau_seche", "peau_normale", "peau_mixte", "peau_grasse", "peau_sensible_atopique", "peau_tout_type", "femme_enceinte", "allaitement","ecran_teinte", "ecran_couvrant"
          ].map(name => (
            <Grid item xs={6} key={name}>
              <FormControlLabel control={<Checkbox checked={formData[name]} onChange={handleChange} name={name} />} label={name.replace(/_/g, ' ')} />
            </Grid>
          ))}

          {/* Dermo Plaints Section */}
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
              Plaintes
            </Typography>
            {loadingPlaints ? (
              <CircularProgress size={24} />
            ) : dermoPlaints.length > 0 ? (
              <Grid container spacing={2}>
                {dermoPlaints.map((plaint) => {
                  const fieldName = plaint.plaint
                    .normalize('NFD')
                    .replace(new RegExp('[̀-ͯ]', 'g'), '') // strip accents (e.g. é, è, ç, î)
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9]+/g, '_')
                    .replace(/^_+|_+$/g, '');

                  return (
                    <Grid item xs={6} key={plaint._id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!formData[fieldName]}
                            onChange={handleChange}
                            name={fieldName}
                          />
                        }
                        label={plaint.plaint}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Typography variant="body2" color="textSecondary">
                Aucune plainte disponible
              </Typography>
            )}
          </Grid>

          <br></br>
            {formData.photo && !showFileInput ? (
                <div>
                  <img src={formData.photo} alt="Current Medicament" style={{ maxWidth: '100%', marginBottom: '10px' }} />
                  <Button variant="outlined" onClick={() => setShowFileInput(true)}>
                    Change Photo
                  </Button>
                </div>
              ) : (
                <input type="file" onChange={handleFileChange} />
              )}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Sauvegarder
            </Button>
          </Grid>
        </Grid>
            
      </form>

    </Paper>
  );
};

export default DermoMedicineForm;
